export default "__VITE_ASSET__N3FL6aVj__"